module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/makeup_6d5c9c.png";